<template>
  <div class="w-100" style="min-height:38px;text-align:left;">
    <b-form>
      <h4>Parámetros</h4>    
      <div class="form-container-row">
        <b-form-group class="form-container-element" label="Sexo" label-for="input-sex">
          <b-form-select 
            v-model="formData.sex" 
            :options="options.optionsSex" 
            id="input-sex" 
          />
        </b-form-group>
        <b-form-group class="form-container-element" label="Edad" label-for="input-age-search">
          <b-form-input 
            v-model="formData.age" 
            :number="true" 
            id="input-age-search"
            aria-describedby="input-age-feedback" 
            :state="$v.formData.age.$invalid ? false : null "
          />
          <b-form-invalid-feedback id="input-age-feedback"> Debe ser un número </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group 
          class="form-container-element"
          label="Tipo de dieta"
          label-for="input-diet">
          <b-form-select id="input-diet"
            v-model="formData.diet_type"
            :options="options.optionsDietType"
            aria-describedby="input-diet-type-feedback" 
            :state="$v.formData.diet_type.$dirty & $v.formData.diet_type.$invalid ? false : null "
          />
          <b-form-invalid-feedback id="input-diet-type-feedback"> Campo obligatorio </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="form-container-row">
        <b-form-group class="form-container-element" label="Estatura (cm)" label-for="input-height">
          <b-form-input 
            v-model="formData.height" 
            :number="true"
            id="input-height" 
            aria-describedby="input-height-feedback"
            :state="!$v.formData.height.decimal || ($v.formData.height.$dirty && !$v.formData.height.required)? false : null "
          />
          <b-form-invalid-feedback v-if="!$v.formData.height.decimal" id="input-height-feedback"> Debe ser un número </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="$v.formData.height.$dirty && !$v.formData.height.required" id="input-height-feedback">
            Campo obligatorio
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group class="form-container-element" label="Peso (kg)" label-for="input-weight">
          <b-form-input 
            v-model="formData.weight" 
            :number="true"
            id="input-weight" 
            aria-describedby="input-weight-feedback"
            :state="!$v.formData.weight.decimal || ($v.formData.weight.$dirty && !$v.formData.weight.required) ? false : null "
          />
          <b-form-invalid-feedback v-if="!$v.formData.weight.decimal" id="input-weight-feedback"> El peso debe ser un número </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="$v.formData.weight.$dirty && !$v.formData.weight.required" id="input-weight-feedback">
            Campo obligatorio
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group class="form-container-element" label="IMC" label-for="input-bmi2">
          <b-form-input 
            v-model="formData.BMI" 
            :number="true"
            id="input-bmi2" 
            aria-describedby="input-bmi-help input-bmi-feedback2"
            :state="$v.formData.BMI.$invalid ? false : null "
          />
          <b-form-invalid-feedback id="input-bmi-feedback2"> Debe ser un número </b-form-invalid-feedback>
          <b-form-text id="input-bmi-help">Sugerido: {{suggestedBmi}}</b-form-text>
        </b-form-group>
      </div>
      <hr />
      <h4>Actividad física</h4>
      <div class="form-container-row">
        <b-form-group class="form-container-element" label="Días de actividad física" label-for="input-wo-days">
          <b-form-input 
            v-model="formData.workout_days" 
            :number="true"
            id="input-wo-days" 
            aria-describedby="input-wo-days-feedback"
            :state="$v.formData.workout_days.$invalid ? false : null "
          />
          <b-form-invalid-feedback id="input-wo-days-feedback"> Debe ser un número entre 2 y 6 </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group class="form-container-element" label="Tiempo de actividad física" label-for="input-wo-time">
          <b-form-select 
            v-model="formData.workout_time" 
            :options="options.optionsTimePerDay"
            id="input-wo-time" 
          />
        </b-form-group>
        <b-form-group class="form-container-element" label="Factor de actividad física" label-for="input-physical-act-factor">
          <b-form-input 
            v-model="formData.physical_activity_factor" 
            :number="true"
            id="input-physical-act-factor" 
            aria-describedby="input-physical-act-help input-physical-factor-feedback"
            :state="$v.formData.physical_activity_factor.$invalid ? false : null "
          />
          <b-form-invalid-feedback id="input-physical-factor-feedback"> Debe ser un número </b-form-invalid-feedback>
          <b-form-text id="input-physical-act-help">Sugerido: {{suggestedPhysicalActivityFactor}}</b-form-text>
        </b-form-group>
      </div>
      <hr />
      <h4>Objetivo</h4>
      <div class="form-container-row">
        <b-form-group class="form-container-element" label="Objetivo" label-for="input-objective">
          <b-form-select 
            v-model="formData.objective" 
            :options="options.optionsObjective"
            id="input-objective" 
            aria-describedby="input-objective-feedback"
            :state="$v.formData.objective.$dirty &&  $v.formData.objective.$invalid ? false : null "
          />
          <b-form-invalid-feedback id="input-objective-feedback"> Campo obligatorio </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group class="form-container-element" label="Ajuste por objetivo" label-for="input-objective-factor">
          <div class="flex-input-group">
            <b-form-select class="flex-input-element-sm"
              v-model="formData.objective_symbol"
              :options="options.optionsObjectiveAdjustment"
            >+</b-form-select>
            <div class="flex-input-element" >
              <b-form-input
                v-model="formData.objective_factor" 
                :number="true"
                id="input-objective-factor" 
                aria-describedby="input-objective-help input-objective-factor-feedback"
                :state="$v.formData.objective_factor.$invalid ? false : null "
              />
              <b-form-invalid-feedback id="input-objective-factor-feedback"> Debe ser un número </b-form-invalid-feedback>
              <b-form-text id="input-objective-help">Sugerido: {{suggestedObjectiveAdjustment}}</b-form-text>
            </div>
          </div>
        </b-form-group>
      </div>
      <hr />
      <RequirementsTable
        :form-data="formData"
      />
      <hr />
      <b-form-group label="Requerimiento final" label-for="input-requirements">
        <b-form-input 
          v-model="formData.requirements" 
          :number="true"
          id="input-requirements" 
          aria-describedby="input-requirements-feedback"
          :state="$v.formData.requirements.$dirty &&  $v.formData.requirements.$invalid ? false : null "
        />
        <b-form-invalid-feedback v-if="$v.formData.requirements.$dirty && !$v.formData.requirements.numeric" id="input-requirements-feedback">
          Debe ser un número
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="$v.formData.requirements.$dirty && !$v.formData.requirements.required" id="input-requirements-feedback">
          Campo obligatorio
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>    
  </div>
</template>

<script>

import { decimal, maxValue, minValue, numeric, required } from 'vuelidate/lib/validators'
import RequirementsTable from '../table/RequirementsTable'

export default {
  name: "RequierementSettings",
  components: {
    RequirementsTable
  },
  model: {
    prop: "dietData",
    event: "change",
  },
  props: {
    dietData: {
      type: Object,
      default: function () {
        return {
          age: undefined,
          height: undefined,
          weight: undefined,
          sex: undefined,
          BMI: undefined,
          workout_days: undefined,
          workout_time: undefined,
          physical_activity_factor: undefined,
          objective: undefined,
          objective_symbol: undefined,
          objective_factor: undefined,
          requirements: undefined
        }
      },
    }
  },
  data: function() {
    return {
      formData: this.dietData,
      options: {
        optionsSex: [
          { value: 1, text: "Mascúlino" },
          { value: 2, text: "Femenino" }
        ],
        optionsTimePerDay: [
          { value: 1, text: "30 mins" },
          { value: 2, text: "45 mins" },
          { value: 3, text: "60 mins" },
          { value: 4, text: "90 mins" },
          { value: 5, text: "120 mins" }
        ],
        optionsObjective: [
          { value: 1, text: "Bajar de peso" },
          { value: 2, text: "Aumentar masa muscular" },
          { value: 5, text: "Mantener peso" }
        ],
        optionsObjectiveAdjustment: [
          { value: 1, text: "+" },
          { value: 2, text: "-" }
        ],
        optionsDietType: [
          { value: 1, text: "Omnívoro (incluye todos los alimentos)" },
          { value: 2, text: "Vegetariano" },
          { value: 4, text: "Pesco vegetariano"},
          { value: 3, text: "Vegano" }
        ]
      }
    };
  },
  computed: {
    suggestedBmi: function () {
      if (isNaN(this.formData.weight) || isNaN(this.formData.height) || !this.formData.weight || !this.formData.weight) {
        return "--"
      }
      else {
        let weight = this.formData.weight
        let height = this.formData.height / 100
        let bmi = weight / ( height  * height )
        return bmi.toFixed(1)
      }
    },
    suggestedPhysicalActivityFactor: function () {
      let days = this.formData.workout_days
      let time = this.formData.workout_time
      if (isNaN(days) || isNaN(time) || !days || !time) {
        return "--"
      }
      else {
        return this.getSuggestedFactor(days, time)
      }
    },
    suggestedObjectiveAdjustment: function () {
      if (this.formData.objective === 1) {
        return "-500 kcal"
      } else if (this.formData.objective === 2) {
        return "+200 kcal"
      } else {
        return "+0 kcal"
      }
    }
  },
  watch: {
    formData: function(val) {
      this.$emit("change", val)
    },
    suggestedBmi: {
      immediate: true,
      handler: function (value) {
        if (isNaN(value)) {
          this.formData.BMI = null
        } else {
          this.formData.BMI = value
        }
      }
    },
    suggestedPhysicalActivityFactor: {
      immediate: true,
      handler: function (value) {
        if (isNaN(value)) {
          this.formData.physical_activity_factor = null
        } else {
          this.formData.physical_activity_factor = value
        }
      }
    },
    "formData.objective": {
      immediate: true,
      handler: function (value) {
        if (value === 1) {
          this.formData.objective_symbol = 2
          this.formData.objective_factor = 500
        } else if (this.formData.objective === 2) {
          this.formData.objective_symbol = 1
          this.formData.objective_factor = 200
        } else {
          this.formData.objective_symbol = 1
          this.formData.objective_factor = 0
        }
      }
    }
  },
  validations: {
    formData:{
      age:  {
        numeric 
      },
      diet_type: {
        required
      },
      height: {
        decimal,
        required
      },
      weight: {
        decimal,
        required
      },
      BMI: {
        decimal
      },
      workout_days: {
        numeric,
        minValue: minValue(2),
        maxValue: maxValue(6)
      },
      workout_time:{
        numeric
      },
      physical_activity_factor: {
        decimal
      },
      objective: {
        required
      },
      objective_factor: {
        numeric
      },
      requirements: {
        numeric,
        required
      }
    }
  },
  methods: {
    getSuggestedFactor(days, time) {
      switch (days) {
        case 2:
          switch (time) {
            case 1: 
            case 2: 
              return 1.25
            case 3: 
            case 4: 
              return 1.3
            case 5: 
              return 1.35
            default:
              return 0
          }
        case 3:
          switch (time) {
            case 1: 
              return 1.25
            case 2: 
            case 3: 
              return 1.3
            case 4: 
              return 1.35
            case 5: 
              return 1.4
            default:
              return 0
          }
        case 4:
          switch (time) {
            case 1: 
              return 1.3
            case 2: 
            case 3: 
              return 1.35
            case 4: 
              return 1.4
            case 5: 
              return 1.45
            default:
              return 0
          }
        case 5:
          switch (time) {
            case 1: 
              return 1.3
            case 2: 
            case 3: 
              return 1.4
            case 4: 
              return 1.45
            case 5: 
              return 1.5
            default:
              return 0
          }
        case 6:
          switch (time) {
            case 1: 
              return 1.3
            case 2: 
            case 3: 
              return 1.45
            case 4: 
              return 1.5
            case 5: 
              return 1.55
            default:
              return 0
          }
        default:
          return 0
      }

    },
    validate: function() {
      this.$v.formData.$touch()
      var isValid = !this.$v.formData.$invalid
      this.$emit('on-validate', isValid)
      return isValid
    }
  }
};
</script>

<style>
  .form-container-row {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
  .form-container-element {
    flex: 1 1 0px;
    padding: 0.5rem;
    width: 0;
  }
  .flex-input-group {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
  .flex-input-element {
    flex: 7 7 80%;
  }
  .flex-input-element-sm {
    flex: 1 1 20%;
  }
</style>